import { QrReader } from "@blackbox-vision/react-qr-reader";
import { useState, useEffect } from "react";
import React from "react";

export const QRScanner = ({
  setInputValue,
  setIsCameraOpen,
  isCameraOpen,
  searchValue,
  setScannerError,
}) => {
  const [newSearchValue, setNewSearchValue] = useState("");
  const [isCameraActive, setIsCameraActive] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleScan = (data) => {
    if (data && data !== searchValue && isCameraOpen) {
      const cleanData = data.includes(":") ? data.split(":").pop() : data;
      setNewSearchValue(cleanData);
    }
  };

  const handleError = (error) => {
    if (error?.message?.includes("denied")) {
      setIsError(true);
    }

    if (error && error.name === "NotAllowedError") {
      setIsCameraActive(false);
    } else if (error && error.name === "NotFoundError") {
      setIsCameraActive(false);
    } else {
      setIsCameraActive(true);
    }
    console.error(error);
  };

  useEffect(() => {
    if (isCameraOpen) {
      if (newSearchValue && newSearchValue !== searchValue) {
        setIsCameraOpen(false);
        setInputValue(newSearchValue);
      }

      if (isError) {
        setTimeout(() => {
          setScannerError(true);
          setTimeout(() => {
            setScannerError(false);
          }, 3000);
          setIsCameraOpen(false);
          setIsError(false);
        }, 250);
      }
    }
  }, [isCameraOpen, newSearchValue, isError]);

  return (
    <div>
      {isCameraOpen && (
        <div>
          <QrReader
            onResult={(result, error) => {
              if (result) {
                handleScan(result.getText());
              }
              if (error) {
                handleError(error);
              }
            }}
            className={`mt-4 mx-[16px] -mb-[60px] custom450:-mb-[30px] custom485:-mb-0 h-fit max-h-[300px] md:mx-[32px]  md:h-[350px] md:border md:border-[#000] overflow-hidden md:rounded-[10px] ${!isCameraActive && 'hidden'}`}
            style={{ height: "calc(fit-content - 10px)" }}
            constraints={{ facingMode: "environment" }}
          />
        </div>
      )}
    </div>
  );
};
